<section class="px-4 py-16">
  <h2 class="text-2xl sm:text-3xl font-bold mb-10 text-center text-aged-paper">
    Productos destacados
  </h2>

  @if (!isLoading && products && products.length > 0) {
    <div>
      <div
        class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4"
        appAnimateStagger
      >
        @for (p of products; track trackByProductId($index, p)) {
          <app-galaxy-card #staggerItem padding="none">
            <div galaxy-card-content class="flex flex-col text-gray-300 h-full">
              <a [routerLink]="['/producto', p.id]" class="w-full block p-4">
                <img
                  [src]="p.urlImage"
                  [alt]="p.name"
                  class="w-full h-40 object-contain rounded-lg drop-shadow-md"
                />
              </a>
              <div class="flex-grow flex flex-col p-4 border-t border-black/5">
                <h3
                  class="text-base font-semibold text-center flex-grow text-aged-paper mb-2"
                >
                  {{ p.name }}
                </h3>
                <div
                  class="text-royal-amethyst font-bold text-xl my-2 text-center"
                >
                  ${{ p.price | number: "1.0-0" }}
                </div>
                <div class="flex gap-2 mt-auto">
                  <a
                    [routerLink]="['/producto', p.id]"
                    appGalaxyButton
                    appGalaxyRipple
                    galaxyVariant="secondary"
                    galaxySize="sm"
                    class="flex-1 block text-center"
                  >
                    Ver Detalles
                  </a>
                </div>
              </div>
            </div>
          </app-galaxy-card>
        }
      </div>
    </div>
  } @else {
    @if (isLoading) {
      <div>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8"
        >
          @for (i of [1, 2, 3, 4]; track i) {
            <app-galaxy-card padding="lg">
              <div galaxy-card-content class="flex flex-col h-full">
                <app-galaxy-skeleton
                  height="12rem"
                  width="100%"
                  borderRadius="0.5rem"
                ></app-galaxy-skeleton>
                <div class="flex-grow flex flex-col pt-4">
                  <app-galaxy-skeleton
                    height="1.25rem"
                    width="80%"
                    borderRadius="0.25rem"
                    class="mx-auto"
                  ></app-galaxy-skeleton>
                  <app-galaxy-skeleton
                    height="1.5rem"
                    width="50%"
                    borderRadius="0.25rem"
                    class="my-3 mx-auto"
                  ></app-galaxy-skeleton>
                  <app-galaxy-skeleton
                    height="2rem"
                    width="100%"
                    borderRadius="9999px"
                    class="mt-auto"
                  ></app-galaxy-skeleton>
                </div>
              </div>
            </app-galaxy-card>
          }
        </div>
      </div>
    } @else {
      <p class="text-center text-gray-400">
        No hay productos destacados para mostrar en este momento.
      </p>
    }
  }
</section>
